import script from "./NewsPageBodyPost.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyPost.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyPost.vue?vue&type=style&index=0&id=27ab17fd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ab17fd"]])

export default __exports__